import React from 'react';
import { detailWrap } from 'styles/table';
import useSummary from '../useSummary';

function Dashboard() {
  const summary = useSummary();

  return (
    <div css={[detailWrap, { marginTop: '24px' }]}>
      <h3>활동정보</h3>
      <ul
        css={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '24px',
          '> li': {
            width: '20%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            'p:nth-of-type(1)': {
              fontWeight: 'bold',
              marginBottom: '8px',
              color: '#8d8d8d',
            },
            'p:nth-of-type(2)': {
              '> span': {
                fontSize: '32px',
                fontWeight: 'bold',
              },
            },
          },
          'li + li': {
            borderLeft: '1px solid grey',
          },
        }}
      >
        <li>
          <p>신청 횟수</p>
          <p>
            <span>{summary.total}</span>회
          </p>
        </li>
        <li>
          <p>총 봉사 시간</p>
          <p>
            <span>{summary.hours}</span>시간
          </p>
        </li>
        <li>
          <p>출석 횟수</p>
          <p>
            <span>{summary.present}</span>회
          </p>
        </li>
        <li>
          <p>지각 횟수</p>
          <p>
            <span>{summary.late}</span>회
          </p>
        </li>
        <li>
          <p>결석 횟수</p>
          <p>
            <span>{summary.absent}</span>회
          </p>
        </li>
      </ul>
    </div>
  );
}

export default Dashboard;
